import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dss-libs-ui-skeleton',
  standalone: true,
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonComponent {}
